import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d380dfe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-info-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "收件信息", -1))
const _hoisted_3 = {
  key: 0,
  class: "value xag-ellipsis"
}
const _hoisted_4 = {
  key: 1,
  class: "value empty"
}

import { withDefaults, computed } from 'vue'
import BlockkWrapper from '../block-wrap.vue'
import { MalfunctionRepairServiceOrderLogisticsItem } from '@/types/malfunction-repair'


export default /*#__PURE__*/_defineComponent({
  __name: 'detail-receive-block',
  props: {
    logistics: { default: () => null }
  },
  setup(__props: any) {

const props = __props as { logistics: MalfunctionRepairServiceOrderLogisticsItem };


const addressStr = computed(() => {
  const { province, city, area, address } = props.logistics
  return `${province === city ? '' : province}${city}${area}${address}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, { title: "收件信息" }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", null, [
          _hoisted_2,
          (_unref(addressStr))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(addressStr)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, "未填写"))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})